const LOCAL_DOMAINS = [
  "127.0.0.1",
  "localhost"
];

export default function isLocalhost(hostname=document.location.hostname) {
  return LOCAL_DOMAINS.includes(hostname);
}